// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2797":"css/admin-app.6821","9238":"css/app.6821"}[chunkId] + ".css";
};